<template>
  <div>
<!--     <div class="vld-parent mycenter">
      <loading :active.sync="isLoading"
      :is-full-page="fullPage"></loading>
    </div>   -->
    <DormList :dorms="dorms" v-if="dorms"/>
    <infinite-loading @infinite="infiniteHandler" spinner="waveDots">
      <div slot="no-more"></div>
      <div slot="no-results"></div>
    </infinite-loading>
    <FixedPopup :dorms="popupDorms" v-if="popupDorms && popupDorms.length > 0"/>
  </div>
</template>

<script>
import DormList from '@/components/DormList'
import FixedPopup from '@/components/FixedPopup'
import axios from 'axios'
import InfiniteLoading from 'vue-infinite-loading'
// import Loading from 'vue-loading-overlay'
import { mapGetters } from 'vuex'
export default {
  name: 'BranchMain',
  components: {
    DormList,
    FixedPopup,
    InfiniteLoading
    // Loading
  },
  metaInfo () {
    return {
      // http://api.yurtlarburada.com/site/universities/dorms/istanbul-teknik-universitesi
      // if no subcomponents specify a metaInfo.title, this title will be used
      title: this.branchedDormTitle ? this.branchedDormTitle : '',
      meta: [
        { vmid: 'description', name: 'description', content: this.universityDetails ? this.universityDetails.description : '' },
        { vmid: 'keywords', name: 'keywords', content: this.universityDetails ? this.universityDetails.keywords : '' }
      ],
      link: [
        { vmid: 'canonical', rel: 'canonical', href: window.location.origin + this.fullPath }
      ]
    }
  },
  data () {
    return {
      branchedDormTitle: null,
      fullPath: '',
      isLoading: false,
      fullPage: true,
      page: 2,
      dorms: null,
      pagination: null,
      popupDorms: null,
      errors: []
    }
  },
  methods: {
    infiniteHandler ($state) {
      let self = this
      const id = window.localStorage.getItem('branchedDormId')
      axios.get(`/site/dorm/branches/${id}?page=${this.page}`)
        .then(response => {
          // self.pagination = response.data.data
          // if (Array.isArray(self.dorms) && Array.isArray(response.data.data.data) !== true && Object.keys(response.data.data.data).length !== 0) {
          if (Array.isArray(self.dorms) && Array.isArray(response.data.data.data) && Object.keys(response.data.data.data).length !== 0) {
            Object.keys(response.data.data.data).forEach(item => {
              self.dorms.push(response.data.data.data[item])
            })
            $state.loaded()
          } else {
            $state.complete()
          }
          // self.dorms = response.data.data.data
          self.popupDorms = response.data.popups
        })
        .catch(e => {
          self.errors.push(e)
          $state.complete()
        })
    },
    getDorms () {
      const id = window.localStorage.getItem('branchedDormId')
      var self = this
      // const url = self.$attrs.redirect ? `/site/dorm/detail/old/${dormID}` : `/site/dorm/detail/${this.$route.params.id}`
      const url = `/site/dorm/branches/${id}`
      // let distinctArray = null
      axios.get(url)
        .then(response => {
          this.isLoading = false
          self.detail = response.data
          this.branchedDormTitle = response.data.center_name
          window.localStorage.setItem('dormLogo', response.data.logo)
          window.localStorage.setItem('branchedDormTitle', response.data.center_name)
          if (response.data.branches) {
            // distinctArray = [...new Set(response.data.branches.map(x => x.district.name))]
            window.localStorage.setItem('branchnumber', response.data.branches.length)
            self.dorms = response.data.branches
            self.allDorms = response.data.branches
          }
        })
    }

  },
  computed: {
    ...mapGetters(['universityDetails'])
  },
  mounted () {
    this.getDorms()
  },
  created () {
    // this.branchedDormTitle = window.localStorage.getItem('branchedDormTitle')
    var myString = this.$route.fullPath
    var lastChar = myString[myString.length - 1]

    if (lastChar === '/') {
      this.fullPath = this.$route.fullPath
    } else {
      this.fullPath = this.$route.fullPath + '/'
    }
  },
  watch: {
    $route () {
      this.getDorms()
    }
  }
}
</script>

<style scoped>
.mycenter {
 display:table;
 margin:0 auto;
}
</style>
